module.exports = __webpack_public_path__ + "img/pharmaceutical_1.1131fe4b.jpg";